'use client';

import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import MuiBreadcrumbs from '@mui/material/Breadcrumbs';
import { useSelector } from '@/app/store'; // Redux integration
import navigation from '@/app/menu-items'; // Your navigation structure
import navigationEcoles from '@/app/menu-items/indexEcoles'; // Your navigation structure
import navigationInstitution from '@/app/menu-items/indexInstitutos'; // Your navigation structure

import { FormattedMessage } from 'react-intl';

// Icons
import { IconChevronRight } from '@tabler/icons-react';
import HomeIcon from '@mui/icons-material/Home';
import HomeTwoToneIcon from '@mui/icons-material/HomeTwoTone';

// Breadcrumb Title Component
const BTitle = ({ title }) => (
  <Grid item>
    <Typography variant="h3" sx={{ fontWeight: 500 }}>
      {title}
    </Typography>
  </Grid>
);

BTitle.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

// Breadcrumb Component
const Breadcrumbs = ({
  card = true,
  custom = false,
  divider = true,
  heading,
  icon = true,
  icons,
  links,
  maxItems = 8,
  rightAlign = true,
  separator = IconChevronRight,
  title = true,
  titleBottom,
  sx,
  ...others
}) => {
  const theme = useTheme();
  const pathname = usePathname();
  const [main, setMain] = useState(null);
  const [item, setItem] = useState(null);
  const [universityOuCollege, setUniversityOuCollege] = useState(0);

  // Redux: Fetch parameters from state
  const { paramMemoire } = useSelector((state) => state.diversParametersRedux);

  // Styling for icons and links
  const iconSX = {
    marginRight: 6,
    marginTop: -2,
    width: '1rem',
    height: '1rem',
    color: theme.palette.secondary.main,
  };

  const linkSX = {
    display: 'flex',
    color: 'grey.900',
    textDecoration: 'none',
    alignContent: 'center',
    alignItems: 'center',
  };

  // Find the active menu item based on the current pathname
  const getActiveItem = (menu) => {
    if (!custom && menu.children) {
      menu.children.forEach((child) => {
        if (child.type === 'collapse') {
          getActiveItem(child);
        } else if (child.type === 'item' && child.url === pathname) {
          setMain(menu);
          setItem(child);
        }
      });
    }
  };

  // Determine active item and main menu
  useEffect(() => {

    paramMemoire.map((item) => {
      // setUniversityID(item.universityID);
    //  setuniversityID(item.universityID);
     setUniversityOuCollege(item.universityOuCollege);
    })

  if(Number(universityOuCollege) ===1)
  {
  navigation.items.forEach((menu) => {
    if (menu.type === 'group') {
      if (menu.url === pathname) {
        setMain(menu);
        setItem(menu);
      } else {
        getActiveItem(menu);
      }
    }
  
  });
}

if(Number(universityOuCollege) ===2)
{
  navigationInstitution.items.forEach((menu) => {
  if (menu.type === 'group') {
    if (menu.url === pathname) {
      setMain(menu);
      setItem(menu);
    } else {
      getActiveItem(menu);
    }
  }
});
}

if(Number(universityOuCollege) ===3)
{
  navigationEcoles.items.forEach((menu) => {
  if (menu.type === 'group') {
    if (menu.url === pathname) {
      setMain(menu);
      setItem(menu);
    } else {
      getActiveItem(menu);
    }
  }

});
}


  }, [pathname, universityOuCollege]);

  // Ensure the breadcrumb always has valid links
  const fallbackUrl = '/'; // Default fallback URL
  const mainUrl = main?.url || fallbackUrl;
  const itemUrl = item?.url || fallbackUrl;

  // Breadcrumb separator
  const SeparatorIcon = separator;
  const separatorIcon = separator ? (
    <SeparatorIcon stroke={1.5} size="16px" />
  ) : (
    '/'
  );

  // Dynamic Breadcrumb Content
  let breadcrumbContent = <Typography />;
  let mainContent = null;
  let itemContent = null;

  // Main Menu Content
  if (main && main.type === 'collapse') {
    mainContent = (
      <Typography
        component={Link}
        href={mainUrl}
        variant="subtitle1"
        sx={linkSX}
        color={pathname === mainUrl ? 'text.primary' : 'text.secondary'}
      >
        {icons && <main.icon style={iconSX} />}
        {main.title}
      </Typography>
    );
  }

  // Active Item Content
  if (item && item.type === 'item') {
    itemContent = (
      <Typography
        component={Link}
        href={itemUrl}
        variant="subtitle1"
        sx={{ ...linkSX, color: 'text.secondary' }}
      >
        {icons && <item.icon style={iconSX} />}
        {item.title}
      </Typography>
    );

    breadcrumbContent = (
      <Card
        sx={
          card
            ? { mb: 3, bgcolor: 'background.default', ...sx }
            : { mb: 3, bgcolor: 'transparent', ...sx }
        }
        {...others}
      >
        <Box sx={{ p: 2 }}>
          <Grid
            container
            direction={rightAlign ? 'row' : 'column'}
            justifyContent={rightAlign ? 'space-between' : 'flex-start'}
            alignItems={rightAlign ? 'center' : 'flex-start'}
            spacing={1}
          >
            {title && !titleBottom && <BTitle title={item.title} />}
            <Grid item>
              <MuiBreadcrumbs
                aria-label="breadcrumb"
                maxItems={maxItems}
                separator={separatorIcon}
                sx={{
                  '& .MuiBreadcrumbs-separator': { width: 16, ml: 1.25, mr: 1.25 },
                }}
              >
                <Typography
                  component={Link}
                  href="/"
                  color="textSecondary"
                  variant="subtitle1"
                  sx={linkSX}
                >
                  {icons && <HomeTwoToneIcon style={iconSX} />}
                  {icon && !icons && <HomeIcon style={iconSX} />}
                  Dashboard
                </Typography>
                {mainContent}
                {itemContent}
              </MuiBreadcrumbs>
            </Grid>
            {title && titleBottom && <BTitle title={item.title} />}
          </Grid>
        </Box>
        {card && divider && <Divider sx={{ mt: 2 }} />}
      </Card>
    );
  }

  return breadcrumbContent;
};

Breadcrumbs.propTypes = {
  card: PropTypes.bool,
  custom: PropTypes.bool,
  divider: PropTypes.bool,
  heading: PropTypes.string,
  icon: PropTypes.bool,
  icons: PropTypes.bool,
  links: PropTypes.array,
  maxItems: PropTypes.number,
  rightAlign: PropTypes.bool,
  separator: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  title: PropTypes.bool,
  titleBottom: PropTypes.bool,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default Breadcrumbs;